import { SetupIntent } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import {
    RedirectCallbackArguments,
    useBillingRedirect
} from "./useBillingRedirect";
import { useSwitcherClient } from "./useSwitcherClient";
export interface UseSetupIntentOptions {
    /** Called when redirect is successful */
    onRedirect?: (
        setupIntent: SetupIntent,
        args: RedirectCallbackArguments
    ) => void;
}

/**
 * A hooks to retrieve and validate a Setup Intent from Stripe
 */
export const useSetupIntent = ({ onRedirect }: UseSetupIntentOptions = {}) => {
    const [setupIntent, setSetupIntent] = useState<SetupIntent | null>(null);

    const { setupIntent: intentFromRedirect } = useBillingRedirect({
        onSetupIntent: onRedirect
    });

    const { dispatchApiRequest } = useSwitcherClient(
        (client) => client.stripeIntents_GetSetupIntent,
        {
            requestImmediately: false
        }
    );

    useEffect(() => {
        const getSetupIntent = async () => {
            const setupIntent =
                intentFromRedirect ??
                ((await dispatchApiRequest()) as SetupIntent);

            setSetupIntent(setupIntent);
        };
        getSetupIntent();
    }, [intentFromRedirect, dispatchApiRequest]);

    return { setupIntent };
};
